import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "hstack gap-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["onClick"]

import {computed, ref, onMounted, watch} from "vue";
import BGrid from "../BGrid/BGrid.vue";
import {useScheduledNoticeStore} from "@/stores/scheduledNoticeStore";
import {ScheduledItem, NotificationScheduleType} from "./types";
import {clone} from "@/utils";


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduledNotices',
  emits: ["edit-click"],
  setup(__props: any, { emit: __emit }) {


const scheduledNoticeStore = useScheduledNoticeStore();

const props = __props;

const emit = __emit;

onMounted(() => {
    scheduledNoticeStore.getScheduledNotices();
});

function handleEditClick(item: ScheduledItem) {
    emit("edit-click", clone(item));
}

function handleCloneClick(item: ScheduledItem) {
    item.id = -1;
    let currentDate = new Date();

    item.schedule.year = currentDate.getFullYear();
    item.schedule.month = currentDate.getMonth() + 1;
    item.schedule.weekday = currentDate.getDay();
    item.schedule.date = currentDate.getDate();
    item.schedule.hour = 0;
    item.schedule.minute = 0;

    emit("edit-click", item);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BGrid, {
      tableOptions: _unref(scheduledNoticeStore).tableOptions,
      items: _unref(scheduledNoticeStore).scheduledNotices,
      columns: _unref(scheduledNoticeStore).columns,
      "show-filter": false,
      "show-paging": false,
      onOptionChange: _cache[0] || (_cache[0] = ($event: any) => (_unref(scheduledNoticeStore).getScheduledNotices()))
    }, {
      "cell.actions": _withCtx(({item}) => [
        _createElementVNode("div", _hoisted_2, [
          (
                            !(item.schedule.type == _unref(NotificationScheduleType).OneTime && item.first_run != '0001-01-01')
                        )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-link ms-0 ps-0 text-start",
                onClick: _withModifiers(($event: any) => (handleEditClick(item)), ["prevent"])
              }, " Edit ", 8, _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-link ms-0 ps-0 text-start",
            onClick: _withModifiers(($event: any) => (handleCloneClick(item)), ["prevent"])
          }, " Clone ", 8, _hoisted_4)
        ])
      ]),
      _: 1
    }, 8, ["tableOptions", "items", "columns"])
  ]))
}
}

})